import { StyledError } from "../styles/form/Form";
import styled from "styled-components/macro";

const CenteredError = styled(StyledError)`
  text-align: center;
  margin: 12px 16px;

  background-color: #fff;
  color: #b00020;
  // border-left: 4px solid #b00020;
  border-radius: 8px; // ✅ mjukare look

  padding: 12px 16px; // ✅ LUFT (viktigast)

  font-size: 0.95rem;
  line-height: 1.5; // ✅ bättre läsbarhet

  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05); // subtil lyft
`;

const Error = ({ errorMessage }) => {
  if (!errorMessage) return null;
  return <CenteredError role="alert">{errorMessage}</CenteredError>;
};

export default Error;
